import { Fragment, useEffect, useState } from "react";
import GradeModeSideBar from "../../components/dashboard/GradeModeSideBar";
import GradingModalWarning from "../../components/dashboard/GradeMode/GradingModalWarning";
import { useDispatch } from "react-redux";
import AnswerQuestion from "../../components/dashboard/AnswerQuestion";
import Dropdown from "react-bootstrap/Dropdown";
import Arrow from "../../assets/images/next-pre.svg";
import circleGreen from "../../assets/images/model/circle-green.svg";
import circleRed from "../../assets/images/model/circle-red.svg";
import circleWhite from "../../assets/images/model/circle-white.svg";
import circleYellow from "../../assets/images/model/circle-yellow.svg";
import GraddingRightBar from "../../components/dashboard/GraddingRightBar";
import DashboardHeader from "../../components/dashboard/DashboardHeader/DashboardHeader";
import { countGraded } from "../../Store/api/professor/dashboard";
import { getAnswer, gradeAnAnswer } from "../../Store/api/activityAnswer";
import { allStudents as allDashboardStudent } from "../../Store/api/professor/dashboard";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { calculateLatePenalty } from "../../utils";

const formatDateToDue = (input) => {
  const date = new Date(input);
  // Extract the month, day, and year from the date
  let month = date.getMonth() + 1; // Months are zero-indexed in JS
  let day = date.getDate();
  let year = date.getFullYear().toString().slice(-2); // Get last two digits of the year

  // Format the month and day with leading zeros if necessary
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;

  // Return the formatted string
  return `${month}.${day}.${year}`;
};

const GradeMode = () => {
  const {
    students: allStudents,
    activities = [],
    totalGraded,
    totalAnswers
  } = useSelector((state) => state.entities.dashboard);
  const dispatch = useDispatch();
  const { answerId, classId } = useParams();
  const [actIndex, setActIndex] = useState(0);
  const [stdIndex, setStdIndex] = useState(0);
  const [noMoreMsg, setNoMoreMsg] = useState("");
  const [isNoMore, setIsNoMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [currentStudent, setCurrentStudent] = useState(null);
  const [isBookExpanded, setIsBookExpanded] = useState(false);
  const [currentActivity, setCurrentActivity] = useState(null);

  const [filteredStudents, setFilteredStudents] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [scrollToId, setScrollToId] = useState(null);

  const [showPopup, setShowPopUp] = useState(false);
  const [actionType, setActionType] = useState("");
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedSections, setSelectedSections] = useState([]);
  const [currentAnswer, setCurrentAnswer] = useState({});
  const [canChangeActivity, setCanChangeActivity] = useState(true);
  const { classes = [] } = useSelector((state) => state.entities.classes);
  useEffect(() => {
    if (currentAnswer?.answers?.some((e) => !e.isGraded)) {
      setCanChangeActivity(false);
    } else {
      setCanChangeActivity(true);
    }
  }, [currentAnswer]);

  const scrollToChapter = (chap, chapSec) => {
    setScrollToId(chap);
  };
  const scrollToSection = (sec) => {
    setScrollToId(sec);
  };
  useEffect(() => {
    if (classId) {
      const selectedClassObj = classes?.find((e) => e._id === classId);
      if (selectedClassObj) setSelectedClass(selectedClassObj);
      if (selectedClassObj)
        setSelectedSections(selectedClassObj?.sections?.map((e) => e._id));
    }
  }, [classId, classes]);

  const scrollToParagraph = (chap, sec, par) => {
    setScrollToId(`${chap}.${sec}.${par}`);
  };

  useEffect(() => {
    if (scrollToId) {
      const div = document.getElementById(scrollToId);
      if (div) {
        div.scrollIntoView({ block: "start", behavior: "smooth" });
        setScrollToId(null);
      }
    }
  }, [scrollToId]);

  useEffect(() => {
    setFilteredStudents(
      selectedSections.length === 0
        ? allStudents
        : allStudents.filter((std) =>
            selectedSections.includes(std.classSection._id)
          )
    );
  }, [allStudents, selectedSections]);
  useEffect(() => {
    setFilteredActivities(
      selectedSections.length > 0
        ? activities.filter((e) =>
            e.classSections?.some((section) =>
              selectedSections.includes(section)
            )
          )
        : activities
    );
  }, [activities, selectedSections]);

  useEffect(() => {
    if (filteredStudents.length > 0) {
      setCurrentStudent(filteredStudents[0]);
    }
  }, [filteredStudents]);
  useEffect(() => {
    if (Object.keys(selectedClass).length > 0) {
      if (selectedClass?.sections) {
        setSelectedSections(selectedClass?.sections?.map((e) => e._id));
      }
    } else {
      setSelectedSections([]);
    }
  }, [selectedClass]);

  useEffect(() => {
    if (filteredActivities.length > 0 && answerId) {
      const i = filteredActivities.findIndex((e) => e._id === answerId);
      const current = filteredActivities[i] || filteredActivities[0];
      setCurrentActivity(current);
      setActIndex(i);
    } else {
      setCurrentActivity(null);
      setActIndex(-1);
    }
  }, [filteredActivities, answerId]);
  const gradeAnswer = () => {
    if (!canChangeActivity) {
      setActionType("grade");
      setShowPopUp(true);
      return;
    }
    setIsLoading(true);
    dispatch(
      gradeAnAnswer({
        body: {
          answerObjectId: currentAnswer._id,
          answers: currentAnswer.answers.map((e) => {
            return { ...e, question: e.question._id };
          }),
          profFeedBack: currentAnswer.profFeedBack
        },
        onSuccess: (res) => {
          if (stdIndex < filteredStudents.length - 1) {
            setStdIndex((old) => old + 1);
            setCurrentStudent(filteredStudents[stdIndex + 1]);
          } else if (actIndex < filteredActivities.length - 1) {
            setActIndex((old) => old + 1);
            setCurrentActivity(filteredActivities[actIndex + 1]);
          } else {
            setStdIndex(0);
            setCurrentStudent(filteredStudents[0]);
            setActIndex(0);
            setCurrentActivity(filteredActivities[0]);
          }
          dispatch(
            countGraded({ onSuccess: (res) => {}, onError: (err) => {} })
          );
          dispatch(
            allDashboardStudent({ onSuccess: () => {}, onError: () => {} })
          );

          setIsLoading(false);
        },
        onError: (error) => {
          if (error.response && error.response.data.message) {
            window.alert(error.response.data.message);
          } else {
            alert("Unknown error!!");
          }
          setIsLoading(false);
        }
      })
    );
  };
  const handleActivityChange = (index) => {
    setActIndex(index);
    setCurrentActivity(filteredActivities[index]);
  };
  const getActivityData = (student, currentActivityId) => {
    return student?.activityanswersdata?.find(
      (item) => item.activity?._id === currentActivityId
    );
  };

  const getStatusIcon = (activity) => {
    if (!activity?.isGraded && !activity?.answers?.length > 0) {
      return circleWhite; // Not submitted
    }

    if (activity?.isGraded) {
      return circleGreen; // Graded
    }

    const submittedTime = new Date(activity?.submittedAt);
    const assignedTime = new Date(activity?.activity?.assignedDate);

    if (submittedTime <= assignedTime) {
      return circleYellow; // Submitted on time
    } else {
      return circleRed; // Submitted late
    }
  };
  useEffect(() => {
    setIsLoading(true);
    if (currentActivity && currentStudent) {
      dispatch(
        getAnswer({
          query: {
            // ...(currentActivity?.assignedDate &&
            //   moment(currentActivity?.assignedDate).isAfter(moment(), 'D') && {
            //     isSubmitted: true,
            //   }),
            activity: currentActivity._id,
            studentSection: currentStudent?.studentSections?._id
          },
          onSuccess: (res) => {
            if (res.data.data.length > 0) {
              const ans = res.data.data[0];
              setCurrentAnswer({
                ...ans,
                answers: !ans?.isSubmitted
                  ? currentActivity?.questions.map((q, i) => ({
                      question: q,
                      answerIndex: -1,
                      answerText: "",
                      isCorrect: false,
                      profFeedback: "",
                      studentSelectedBanks: [],
                      grade: 0,
                      givenMarks: 0,
                      totalMarks: q?.score || 1,
                      type: q?.type
                    }))
                  : ans.answers
              });
              setIsLoading(false);
              setIsNoMore(false);
              setNoMoreMsg("");
            } else {
              setNoMoreMsg(
                `${currentStudent?.firstName} has not yet submitted ${currentActivity?.title}`
              );
              setIsNoMore(true);
              setIsLoading(false);
            }
            setIsLoading(false);
          },
          onError: (err) => {
            setIsLoading(false);
          }
        })
      );
    } else {
      setIsNoMore(false);
      setNoMoreMsg("");
      setCurrentAnswer(null);
      setIsLoading(false);
    }
  }, [currentActivity, currentStudent, dispatch]);
  return (
    <div className="grading_wrapper">
      <div
        className={`left_side_bar_grade_mode ${
          isBookExpanded ? "expanded" : ""
        }`}
        style={{ overflowY: "clip" }}>
        <GradeModeSideBar
          setIsBookExpanded={setIsBookExpanded}
          currentActivity={{
            ...currentActivity,
            label: currentActivity?.title,
            value: currentActivity?._id
          }}
          anchorBook={scrollToParagraph}
          scrollChapter={scrollToChapter}
          scrollSection={scrollToSection}
          activity={currentActivity}
          scrollId={scrollToId}
          setScrollId={setScrollToId}
          activities={filteredActivities}
          notAllowed={!canChangeActivity}
          setLink={(val) => {
            setActionType(val);
            setShowPopUp(true);
          }}
        />
      </div>
      <div className={`center_box ${isBookExpanded ? "minimized" : ""}`}>
        <DashboardHeader
          onSelectClass={(clas) => {
            setSelectedClass((old) => {
              if (Object.keys(old).length === 0) {
                return clas;
              } else {
                if (old._id === clas._id) {
                  return {};
                } else {
                  return clas;
                }
              }
            });
          }}
          onSelectSection={(id) => {
            setSelectedSections((old) =>
              old.includes(id) ? old.filter((e) => e !== id) : [...old, id]
            );
          }}
          selectedClass={selectedClass}
          selectedSections={selectedSections}
          notAllowed={!canChangeActivity}
          setLink={(val) => {
            setActionType(val);
            setShowPopUp(true);
          }}
        />
        {isLoading ? (
          "Loading...."
        ) : (
          <Fragment>
            <div className="grading_box">
              <div
                className={`gradding_main ${
                  isBookExpanded ? "maximized" : ""
                }`}>
                {!isNoMore ? (
                  <Fragment>
                    <div className="gradding_progressbar">
                      <h1 className="mb-0" style={{ width: "14%" }}>
                        {currentAnswer?.hasOwnProperty("grade")
                          ? currentAnswer?.grade
                              // .filter((e) => e.isGraded)
                              //     .length
                              //     ? currentAnswer.answers
                              //         .filter((e) => e.isGraded)
                              //         .reduce((acc, next) => acc + next.grade, 0)
                              .toFixed(1)
                          : "--"}
                        %
                      </h1>
                      {currentAnswer?.answers?.map((answer, index) => (
                        <div
                          className={`bar_1 cursor`}
                          style={{
                            background: !answer?.isGraded
                              ? "#D2CFCB"
                              : (answer?.givenMarks / answer?.totalMarks) *
                                  100 >
                                80
                              ? "#49abab"
                              : (answer?.givenMarks / answer?.totalMarks) *
                                  100 >
                                50
                              ? "#FFBF00"
                              : "rgb(174, 38, 4)"
                          }}
                          key={index}
                          onClick={(e) => {
                            const div = document.getElementById(answer._id);
                            if (div) {
                              div.scrollIntoView({ block: "start" });
                            }
                          }}></div>
                      ))}
                    </div>
                    <div className="gradding_activity_box">
                      <div className="gradding_top">
                        <div className="d-flex justify-content-between">
                          <h3>
                            {currentAnswer?.answers?.some(
                              (e) => e.type === "fr" || e.type === "sa"
                            )
                              ? "teacher-graded"
                              : "auto-graded"}
                          </h3>
                          {moment(currentActivity?.assignedDate).isBefore(
                            moment(currentAnswer?.submittedAt),
                            "D"
                          ) ||
                          (currentAnswer?.isSubmitted && currentAnswer) ? (
                            <h6
                              style={{ color: "#AE2604" }}
                              className="ft_12 fw-700">
                              {calculateLatePenalty({
                                ...currentActivity,
                                activityAnswers: [currentAnswer]
                              })}
                              % late penalty
                            </h6>
                          ) : (
                            <h6></h6>
                          )}
                          <div className="d-flex flex-column">
                            <div className="d-flex" style={{ gap: "10px" }}>
                              {currentAnswer?.isSubmitted ? (
                                <h3>{`SUBMITTED ${formatDateToDue(
                                  currentAnswer?.submittedAt
                                )}`}</h3>
                              ) : (
                                <h3 style={{ color: "rgb(174, 38, 4)" }}>
                                  Not submitted
                                </h3>
                              )}
                              <h3
                                style={{
                                  ...(!currentAnswer?.isSubmitted && {
                                    color: "rgb(174, 38, 4)"
                                  })
                                }}>
                                {!currentAnswer?.isSubmitted
                                  ? "Past Due"
                                  : "Due"}{" "}
                                {`${formatDateToDue(
                                  currentActivity?.assignedDate
                                )}`}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h4 className="v_more">
                            <u>chapter {currentActivity?.chap?.order}</u>
                          </h4>
                          <h4 className="v_more">
                            {currentAnswer?.createdBy?.firstName}{" "}
                            {currentAnswer?.createdBy?.lastName}
                          </h4>
                        </div>
                      </div>
                      <div className="answer_title_box">
                        <h2>{currentActivity?.title}</h2>
                        <p className="pts">
                          <b> {currentActivity?.score}</b> pts |{" "}
                          {currentActivity?.questions?.length} questions
                        </p>
                      </div>
                      <div className="answer_discreption_box">
                        <p>
                          {currentActivity?.description || "No Description"}
                        </p>
                      </div>
                      <Fragment>
                        {currentAnswer?.answers?.map((answer, index) => (
                          <AnswerQuestion
                            currentAnswer={currentAnswer}
                            answer={answer}
                            index={index}
                            setGrade={(grade) => {
                              const { activitySettings } =
                                currentStudent?.class;
                              const { percentage, type } =
                                activitySettings?.pastDuePenalty;
                              let gradeToDeduct = 0;
                              if (
                                currentActivity.assignedDate &&
                                moment(currentActivity.assignedDate).isBefore(
                                  moment(currentAnswer.submittedAt)
                                )
                              ) {
                                const daysDiff = moment(
                                  currentAnswer.submittedAt
                                ).diff(
                                  moment(currentActivity.assignedDate),
                                  "days"
                                );
                                if (type !== "perday") {
                                  gradeToDeduct = type === "none" ? 0 : 100;
                                } else {
                                  gradeToDeduct = percentage * daysDiff;
                                }
                              }
                              setCurrentAnswer((old) => {
                                let calculatedGrade =
                                  old.answers
                                    .filter((e, i) => i !== index)
                                    .reduce(
                                      (acc, next) => acc + next.grade,
                                      0
                                    ) +
                                  grade -
                                  gradeToDeduct;
                                const newGrade =
                                  calculatedGrade < 0 ? 0 : calculatedGrade;
                                return {
                                  ...old,
                                  grade: newGrade,
                                  answers: old.answers.map((e, i) =>
                                    i === index
                                      ? {
                                          ...e,
                                          grade:
                                            (((grade / 100) *
                                              answer.question.score) /
                                              Number(currentActivity?.score)) *
                                            100,
                                          isGraded: true,
                                          totalMarks: answer.question?.score,
                                          givenMarks:
                                            (grade / 100) *
                                            Number(answer.question?.score)
                                        }
                                      : e
                                  )
                                };
                              });
                            }}
                            setProfessorFeedBack={(feedback) => {
                              setCurrentAnswer((old) => {
                                return {
                                  ...old,
                                  answers: old.answers.map((e, i) =>
                                    i === index
                                      ? { ...e, profFeedback: feedback }
                                      : e
                                  )
                                };
                              });
                            }}
                          />
                        ))}
                      </Fragment>

                      <h3 className="v_more">Instructor feedback</h3>
                      <textarea
                        className="answer_feedback"
                        value={currentAnswer?.profFeedBack}
                        onChange={(e) => {
                          setCurrentAnswer((old) => {
                            return { ...old, profFeedBack: e.target.value };
                          });
                        }}
                        placeholder="Response goes here">
                        {currentAnswer?.profFeedBack}
                      </textarea>
                    </div>
                  </Fragment>
                ) : (
                  <div className="gradding_activity_box">{noMoreMsg}</div>
                )}
                <div className="gradding_bottom_navigation">
                  <div className="navigation_wrapper">
                    <p>
                      <b>
                        {totalGraded} / {totalAnswers}
                      </b>{" "}
                      graded
                    </p>
                    <div className="dropdown_wrapper">
                      <Dropdown style={{ backgroundColor: "#fff" }}>
                        <Dropdown.Toggle
                          variant="customized"
                          className="customized_dropdown"
                          id="dropdown-basic"
                          style={{ fontWeight: "500", fontFamily: "Inter" }}>
                          Student Select
                          {/* {`${currentStudent?.firstName} ${currentStudent?.lastName}`.length > 20 ? `${currentStudent?.firstName} ${currentStudent?.lastName}`.slice(0, 20) + '...' : `${currentStudent?.firstName} ${currentStudent?.lastName}`} */}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className="all-student"
                          style={{
                            borderBottom: "none",
                            inset: "auto auto -5px 0px",
                            transform: "translate3d(0px, -37px, 0px)"
                          }}>
                          {filteredStudents?.map((student, index) => (
                            <Dropdown.Item
                              key={index}
                              className={`student-item ${
                                stdIndex === index ? "focused" : ""
                              }`}
                              onClick={() => {
                                setCurrentStudent(student);
                                setStdIndex(index);
                              }}
                              style={{
                                ...(stdIndex === index && {
                                  background: "#e9ecef",
                                  color: "black"
                                }),
                                display: "flex",
                                alignItems: "center",
                                gap: "12px"
                              }}>
                              <img
                                src={getStatusIcon(
                                  getActivityData(student, currentActivity?._id)
                                )}
                                alt="status"
                              />
                              {student?.firstName} {student?.lastName}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <button
                      className="navigational_buttons"
                      disabled={stdIndex === 0}
                      onClick={() => {
                        setStdIndex((old) => old - 1);
                        setCurrentStudent(filteredStudents[stdIndex - 1]);
                      }}>
                      <img
                        src={Arrow}
                        alt="next"
                        style={{
                          transform: "rotate(180deg)",
                          marginRight: "10px"
                        }}
                      />
                      Prior Student
                    </button>
                    <button
                      className={`navigational_buttons`}
                      disabled={stdIndex === filteredStudents.length - 1}
                      onClick={() => {
                        setStdIndex((old) => old + 1);
                        setCurrentStudent(filteredStudents[stdIndex + 1]);
                      }}>
                      Next Student
                      <img
                        src={Arrow}
                        alt="pre"
                        style={{ marginLeft: "10px" }}
                      />{" "}
                    </button>
                  </div>
                </div>
              </div>
              <GraddingRightBar
                handleActivityChange={handleActivityChange}
                length={filteredActivities?.length}
                isMinimized={isBookExpanded}
                isNoMore={isNoMore}
                activities={filteredActivities}
                actIndex={actIndex}
                setActIndex={setActIndex}
                activity={{
                  ...currentActivity,
                  label: currentActivity?.title,
                  value: currentActivity?._id
                }}
                setCurrentActivity={setCurrentActivity}
                gradeAnswer={gradeAnswer}
                setIsMinimized={setIsBookExpanded}
              />
            </div>
          </Fragment>
        )}
      </div>
      {showPopup && (
        <GradingModalWarning
          onHide={() => {
            setShowPopUp(false);
          }}
          onSuccess={() => {
            if (actionType === "grade") {
              gradeAnswer();
            } else {
              window.location.href = actionType;
            }
          }}
        />
      )}
    </div>
  );
};
export default GradeMode;
